import { NgModule } from '@angular/core';
import { NkFooterComponent } from './footer.component';

@NgModule({
  imports: [
    NkFooterComponent
  ],
  exports: [NkFooterComponent],
})
export class NkFooterModule {}
